import _sfc_main from "./component-library168.mjs";
import "./component-library169.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _a, _b;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _vm.pages && _vm.pages.length > 1 ? _c("nav", { ref: "carouselNavigationElement", staticClass: "carousel-navigation", class: { "carousel-navigation--page-hidden": _vm.hidePages }, attrs: { "role": "navigation", "aria-label": _vm.ariaLabel } }, [_c(_setup.ForwardBackwardButton, { staticClass: "carousel-navigation__button carousel-navigation__button--previous", attrs: { "aria-label": _vm.labelPrev, "disabled": ((_a = _setup.activePage) == null ? void 0 : _a.number) === 0 && !_vm.infinity, "primary": _vm.primary, "secondary": _vm.secondary }, on: { "clicked": _setup.clickPrev } }), !_vm.hidePages ? _c("ul", { staticClass: "carousel-navigation__container" }, _vm._l(_vm.pages, function(page, key) {
    return _c("li", { key, staticClass: "carousel-navigation__entry" }, [_c(_setup.LinkButton, { staticClass: "carousel-navigation__link", class: { "carousel-navigation__link--active": page.active }, attrs: { "tag": "button", "type": "button", "icon-only": "", "outline": "", "aria-label": _setup.ariaLabelForPageNumber(_vm.pages, page), "aria-current": page.active ? "page" : void 0 }, on: { "click": function($event) {
      return _vm.$emit("update", page.number);
    } } })], 1);
  }), 0) : _vm._e(), _c(_setup.ForwardBackwardButton, { staticClass: "carousel-navigation__button carousel-navigation__button--next", attrs: { "direction": "right", "aria-label": _vm.labelNext, "disabled": ((_b = _setup.activePage) == null ? void 0 : _b.number) === _vm.pages.length - 1 && !_vm.infinity, "primary": _vm.primary, "secondary": _vm.secondary }, on: { "clicked": _setup.clickNext } })], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "158cd9e9",
  null,
  null
);
const CarouselNavigation = __component__.exports;
export {
  CarouselNavigation as default
};
